<template>
  <div class="projects">
    <ProjectsFilter @update="reload" />
    <v-btn
      class="hil-fab"
      dark
      fab
      right
      bottom
      color="accent"
      @click="addDialog = true"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-if="addDialog" v-model="addDialog" width="1000">
      <ProjectAdd @close="addDialog = false" @added="reload()" />
    </v-dialog>
    <ProjectsView @update="reload()" :column="filters.column" />
  </div>
</template>

<script>
import ProjectsView from "../components/ProjectsView";
import ProjectsFilter from "../components/ProjectsFilter";
import ProjectAdd from "../components/ProjectAdd";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "projects",
  components: {
    ProjectAdd,
    ProjectsView,
    ProjectsFilter
  },
  props: {
    mode: {
      type: String,
      required: true,
      default: "reloc"
    }
  },
  data() {
    return {
      addDialog: false
    };
  },
  beforeMount() {
    this.reload();
  },
  watch: {
    $route() {
      this.reload();
    }
  },
  computed: {
    ...mapState("projects", ["filters"]),

    columns() {
      if (this.$route.path === "/reloc") {
        return [
          "researchStarted",
          "visitScheduled",
          "caseAccepted",
          "leaseFetched",
          "awaitingSignature",
          "signed",
          "submittedToHil",
          "docsLease"
        ];
      } else if (this.$route.path === "/compta") {
        return ["sentToAL", "relanceAL", "paid"];
      } else {
        // Sales
        return [
          "toAssign",
          "projectCreated",
          "toCall",
          "eligibility",
          "docsMobiPass"
        ];
      }
    }
  },
  methods: {
    ...mapActions("projects", {
      listProjects: "list"
    }),
    ...mapMutations("projects", ["setColumns"]),

    async reload() {
      this.addDialog = false;
      this.setColumns(this.columns);
      await this.listProjects();
    }
  }
};
</script>
